/********************************************************* {COPYRIGHT-TOP} ***
 * Licensed Materials - Property of IBM
 *
 * (C) Copyright IBM Corporation 2016, 2022
 *
 * All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 ********************************************************** {COPYRIGHT-END} **/

import React, { Suspense, lazy } from 'react';
import PropTypes from 'prop-types';
import { Loading } from 'carbon-components-react';
const ReactJson = lazy(() => import('react-extreme-json-view'));

const Load = () => <Loading small withOverlay={false} data-testid={'json-loading-icon'} />;

const ViewableJSONDisplay = ({ content, jsonName = null }) => {
  return (
    <>
      {!content && <Load />}
      {content && (
        <div data-testid={'json-data'}>
          <Suspense fallback={<Load />}>
            <ReactJson
              src={content}
              enableClipboard={false}
              quotesOnKeys={true}
              name={jsonName}
              displayDataTypes={false}
              displayObjectSize={false}
              displayArrayKey={false}
              collapsed={5}
              theme={{
                base00: '#f4f4f4',
                base01: '#ddd',
                base02: '#ddd',
                base03: '#444',
                base04: 'purple',
                base05: '#444',
                base06: '#444',
                base07: '#606',
                base08: '#444',
                base09: '#008000',
                base0A: 'rgba(70, 70, 230, 1)',
                base0B: 'rgba(70, 70, 230, 1)',
                base0C: '#00008b',
                base0D: 'rgba(70, 70, 230, 1)',
                base0E: 'rgba(70, 70, 230, 1)',
                base0F: 'rgba(70, 70, 230, 1)'
              }}
              style={{ fontFamily: "'IBM Plex Sans Mono', 'Menlo', 'DejaVu Sans Mono', 'Bitstream Vera Sans Mono', Courier", fontSize: '14px' }}
            />
          </Suspense>
        </div>
      )}
    </>
  );
};

ViewableJSONDisplay.propTypes = {
  content: PropTypes.oneOfType([PropTypes.object, PropTypes.array]), // JSON Content to be displayed
  jsonName: PropTypes.string // Name to be displayed at top of JSON Viewer
};

export default ViewableJSONDisplay;
